const minAdults = parseInt(process.env.VUE_APP_MIN_ADL)
const maxAdults = parseInt(process.env.VUE_APP_MAX_ADL);
const minChildren = parseInt(process.env.VUE_APP_MIN_CHD);
const maxChildren = parseInt(process.env.VUE_APP_MAX_CHD);
const minInfants = parseInt(process.env.VUE_APP_MIN_INF);
const maxInfants = parseInt(process.env.VUE_APP_MAX_INF);

const state = { 
    client: { title: '', firstName: '', lastName: '', age: 'ADL', email: '' },
    passengers: [],
    noOfAdults: minAdults,
    noOfChildren: minChildren,
    noOfInfants: minInfants,
};

const getters = {
    getMinAdults() { return minAdults; },
    getMaxAdults() { return maxAdults; },
    getMinChildren() { return minChildren; },
    getMaxChildren() { return maxChildren; },
    getMinInfants() { return minInfants; },
    getMaxInfants() { return maxInfants; },
    getPassengersToRoom(state) 
    { 
        return state.noOfAdults + state.noOfChildren;
    },
    getNoOfADLPassengers(state) { return state.passengers.filter((p) => { return p.age == 'ADL' }).length; },
    getNoOfCHDPassengers(state) { return state.passengers.filter((p) => { return p.age == 'CHD' }).length; },
    getNoOfINFPassengers(state) { return state.passengers.filter((p) => { return p.age == 'INF' }).length; }
}

const mutations = { 
    setClient: (state, payload) => {
        state.client = payload;
    },
    setNoOfAdults: (state, payload) => {
        state.noOfAdults = payload;
    },
    setNoOfChildren: (state, payload) => {
        state.noOfChildren = payload;
    },
    setNoOfInfants: (state, payload) => {
        state.noOfInfants = payload;
    },
    resetPassengers: (state) => {
        state.passengers.length = 0;
    },
    addPassenger: (state, payload) => {
        state.passengers.push(payload);
    },
};

const actions = {
    setClient: (context, payload) => {
        context.commit('setClient', payload);
    },
    setNoOfAdults: (context, payload) => {
        context.commit('setNoOfAdults', payload);
    },
    setNoOfChildren: (context, payload) => {
        context.commit('setNoOfChildren', payload);
    },
    setNoOfInfants: (context, payload) => {
        context.commit('setNoOfInfants', payload);
    },
    setClientIsTravelling: ({ state, commit }, payload) => {
        commit('setClientIsTravelling', payload);
        let passenger = state.passengers.find((p) => p.id == 1);
        passenger.editable = payload;

        commit('setPassenger', passenger);
    },
    initPassengers({ state, getters, commit }) {
        // don't re-initialise if collecition and counts are the same
        if (state.noOfAdults == getters.getNoOfADLPassengers && 
            state.noOfChildren == getters.getNoOfCHDPassengers && 
            state.noOfInfants == getters.getNoOfINFPassengers) {
                return;
        }
        
        // reset the passengers array
        commit('resetPassengers');

        // build up the passengers array based on selections
        for(let p = 1; p <= state.noOfAdults; p++) {
            commit('addPassenger', { passengerId: p, title: '', firstName: '', lastName: '', age: 'ADL', dietaryRequirements: '', editable: true });
        }

        let offset = state.noOfAdults;
        for (let p = offset + 1; p <= state.noOfChildren + offset; p++) {
            commit('addPassenger', { passengerId: p, title: '', firstName: '', lastName: '', age: 'CHD', dietaryRequirements: '', editable: true });
        }

        offset += state.noOfChildren;
        for (let p = offset + 1; p <= state.noOfInfants + offset; p++) {
            commit('addPassenger', { passengerId: p, title: '', firstName: '', lastName: '', age: 'INF', dietaryRequirements: '', editable: true });
        }
    },
};

export default { 
    state,
    getters,
    mutations, 
    actions
};